import { useEffect, useState } from 'react';

const useFormState = ({ initialValues, isOpen, mode = 'create' }) => {
  const [formData, setFormData] = useState(initialValues || {});
  const [baseline, setBaseline] = useState(initialValues || {});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const next = initialValues || {};
      setFormData(next);
      setBaseline(next);
    }
  }, [isOpen, initialValues]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:
        type === 'checkbox'
          ? checked
          : type === 'number' && value === ''
            ? null
            : type === 'number'
              ? Number(value)
              : value,
    }));
  };

  const setField = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const isDirty = JSON.stringify(formData) !== JSON.stringify(baseline);

  const isCreateDisabled = (fields = []) =>
    fields
      .filter((f) => f.required)
      .some((f) => {
        const v = formData[f.name];
        return v === null || v === undefined || v === '';
      });

  const isSubmitDisabled =
    mode === 'edit' ? !isDirty : false;

  const reset = () => {
    setFormData(baseline);
  };

  return {
    formData,
    setFormData,
    handleChange,
    setField,
    isLoading,
    setIsLoading,
    isDirty,
    isCreateDisabled,
    isSubmitDisabled,
    reset,
  };
};

export default useFormState;
